<style lang="scss" scoped>


</style>
<template>

	<el-button v-if="parentYt&&parentYt.isSearchNeedHide"
		:icon="parentYt.isSearchHidden?'yicon yicon-dblarrow_down':'yicon yicon-dblarrow_up'" type="text"
		@click="parentYt.expandSearch()">{{' '}}{{$t(parentYt.isSearchHidden?'gengduo':'shouqi')}}</el-button>
</template>
<script>
	export default {
		name: 'yi_curd_expand_button',
		props: {
			isAutoExpand: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				parentYt: null,
			};
		},

		created() {
			this.parentYt = this.getParentYt(this.$parent)
				if(this.isAutoExpand&&this.parentYt){
					this.parentYt.expandSearch()
				}
		},
		destroyed() {},
		computed: {

		},
		methods: {
			getParentYt(node) {
				if ( node.$options.name == "yi_curd_table") {
					return node
				} else {
					return this.getParentYt(node.$parent)
				}
			}
		},
		watch: {},
		mounted() {}
	};
</script>
